import { useI18n } from '@change-corgi/core/react/i18n';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import type { ShareAction } from 'src/app/shared/hooks/share';

import { useQRCodeShare } from './useQRCodeShare';

type Channel = 'qrcode';

export function usePetitionUrlQRCode(): ModelHookResult<{
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename: string;
	shareAction: ShareAction<Channel> | null;
}> {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const { translate } = useI18n();
	const shareAction = useQRCodeShare();

	return {
		data: {
			slugOrId: petitionId,
			displaySize: 80,
			displayType: 'WEB_PETITION_PAGE_VIEW',
			downloadType: 'WEB_PETITION_PAGE_DOWNLOAD',
			descriptionText: translate('corgi.petition.details.qr_code.description_text'),
			downloadLinkText: translate('corgi.petition.details.qr_code.download_link_text'),
			downloadFilename: translate('corgi.petition.details.qr_code.filename'),
			shareAction,
		},
	};
}
